import React, { createContext, useState, ReactNode } from 'react';

import { useAppDispatch, useAppSelector } from "../Store/hooks";
import { clearAuthSlice, fetchingUserDetails, setIsAuthenticated, setUserDetails } from "../Store/authSlice";
import { isLogin } from "./authService";

import { showToaster } from "../Store/toastSlice";
import { GetApiMethod } from "../Utils/ApiService";

import { LoadingComponent } from '../Components/Loading';
import { DisplayErrorMessages } from '../Utils/HelperService';


interface AuthContextProps {
    isAuthenticated: boolean;
}

const CheckLoginUser = () => {
    const dispatch = useAppDispatch();
    let fetchingUserData = React.useRef<boolean>(false);

  const fetchUserDetails = React.useCallback(() => {
  GetApiMethod('user/profile')
    .then((res: { data: { data: any } }) => {
      if (res?.data?.data?.data) {
        dispatch(setUserDetails(res.data?.data?.data));
        dispatch(setIsAuthenticated(true));
        
      }
      dispatch(fetchingUserDetails(false));
    })
    .catch((err: { response: { data: { message: any } } }) => {
      const error = DisplayErrorMessages(err);
      dispatch(
        showToaster({
          dialogBgColor: 'bg-danger',
          dialogMsg: error || 'Unauthorized',
          showDialog: true,
          timer: '5000'
        })
      );
      dispatch(clearAuthSlice()); // Clear auth state on failure
      dispatch(fetchingUserDetails(false));
    });
}, [dispatch]);


    React.useEffect(() => {
        if (isLogin()) {
            if (!fetchingUserData.current) {
                fetchingUserData.current = true;
                dispatch(fetchingUserDetails(true));
                fetchUserDetails();
            }
        } else {
            dispatch(fetchingUserDetails(false));
            localStorage.clear();
            dispatch(clearAuthSlice());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined);

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    let authState = useAppSelector((state) => state.auth);
      CheckLoginUser(); 
    const [isAuthenticated] = useState<boolean>(true);
     console.log("authState.loading2", authState.loading);
    return (
        <AuthContext.Provider value={{ isAuthenticated }}>
            {authState.loading ? <LoadingComponent /> : (children)}
        </AuthContext.Provider>
    );
};



export default CheckLoginUser;
